import {combineReducers} from 'redux';
import settings from './settings';
import players from './players';

const reducers = {
    settings,
    players,
};

export default combineReducers(reducers);
